import React from 'react'
import { trabajos } from '../data/trabajos';
import img1 from './layout/assets/img/applicationCS.jpg';
import img2 from './layout/assets/img/desarrolloweb.jpg';
import img3 from './layout/assets/img/api.jpg';
import img4 from './layout/assets/img/testing.jpg';

const imagepath = require.context('./layout/assets/img/', true)

export const Portafolio = () => {
  return (
    <div>
      <h1 className='initial__title'>Portafolio</h1>
      <section className='portfolio__gallery'>
        {
          trabajos.map(trabajo => {
            return (
              <figure className="gallery__item" key={trabajo.id}>
                <div className="gallery__tech">
                     <span >{trabajo.tecnologia}</span>
                </div>
                <div class="gallery__container-image">
                  <a href={trabajo.url} target="_blank">
                    <img src={ imagepath(`./${trabajo.imagen}` )}
                    alt="type 1" 
                    class="gallery__image" />
                  </a>
                </div>
                <figcaption class="gallery__title">{trabajo.nombre}</figcaption>
                <i className={`gallery__icon ${trabajo.icono}`}></i>
                <span class="gallery__category">{trabajo.categoria}</span>
                <span>{trabajo.descripcion}</span>
              </figure>
            )
          })
        }
      </section>
    </div>
  )
}
